export const SORT_OPTIONS = {
  SPONSORED: 'sponsored',
  USER_RATING: 'ratings',
  REVIEWS_COUNT: 'reviews',
}
